import { trackEvent } from './analytics.js';

const HEARTBEAT_INTERVAL_MS = 15000;

const getVisibilityState = () => document.visibilityState || 'visible';

export const initGameEngagement = (iframe, slug) => {
  if (!iframe || !slug) return null;

  let playing = false;
  let timerId = null;

  const sendHeartbeat = () => {
    if (!playing || getVisibilityState() !== 'visible') return;
    trackEvent('game_playing', {
      game_slug: slug,
      engagement_time_msec: HEARTBEAT_INTERVAL_MS,
    });
  };

  const startHeartbeat = () => {
    if (timerId !== null) return;
    timerId = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
  };

  const stopHeartbeat = () => {
    if (timerId === null) return;
    window.clearInterval(timerId);
    timerId = null;
  };

  const startPlaying = () => {
    if (playing) return;
    playing = true;
    trackEvent('game_start', { game_slug: slug });
    startHeartbeat();
  };

  const handleBlur = () => {
    if (document.activeElement === iframe) {
      startPlaying();
    }
  };

  const handleIframePointerDown = () => {
    startPlaying();
  };

  const cleanup = () => {
    stopHeartbeat();
    window.removeEventListener('blur', handleBlur);
    window.removeEventListener('pagehide', cleanup);
    iframe.removeEventListener('pointerdown', handleIframePointerDown);
  };

  window.addEventListener('blur', handleBlur);
  window.addEventListener('pagehide', cleanup);
  iframe.addEventListener('pointerdown', handleIframePointerDown);

  return cleanup;
};
